import { PersonExtendedWIthTags } from "./UpdatePersonResponse";

export interface ResearchTaskSchema {
  id: string;
  task_status: ResearchTaskStatus;
  task_result: PersonExtendedWIthTags | null;
  created_at: Date;
  updated_at: Date;
  error: string | null;
}

export interface ResearchTaskStatusResponse {
  task_status: ResearchTaskStatus;
  task_result: PersonExtendedWIthTags | null;
}

export enum ResearchTaskStatus {
  RUNNING = "running",
  COMPLETED = "completed",
  FAILED = "failed",
}
